// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"7000f063","232":"50099a16","453":"f8137231","667":"35a0da76","823":"d424f0a2"}[chunkId] + ".chunk.js";
};